import {LoadingIcon} from '../svg/LoadingIcon';

export const SuspenseFallback = () => (
  <div className="suspense-fallback">
    <LoadingIcon className="suspense-fallback__spinning-icon" ratio={1.334} />
  </div>
);
